<template>
  <div>
    <div class="aedw-package-buttons">
      <template v-for="(item, key) in posList">
        <button
          :key="key"
          class="m-1 btn"
          :class="{ 
              'btn-primary': isSelected(item), 
              'btn-outline-primary': !isSelected(item) 
            }"
          @click="onSelect(item)"
        >{{ item.short_description }}</button>
      </template>
    </div>

    <template v-if="posSelected">
      <PackageList
        :useCustomTemplate="useCustomTemplate"
        :templateName="templateName"
        :posId="posSelected"
        :params="mergedParams"
        :config="config"
        :useDefaultGridCols="useDefaultGridCols"
        :disableGetPackagesOnRender="disableGetPackagesOnRender"
      />
    </template>
  </div>
</template>

<style lang="scss">
.aedw-package-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 25px;
}

</style>

<script>
import PackageList from "./package-list.vue";

export default {
  props: [
    "posList",
    "useCustomTemplate",
    "templateName",
    "config",
    "useDefaultGridCols",
    "params",
    "disableGetPackagesOnRender"
  ],

  components: { PackageList },

  data() {
    return {
      posSelected: null,
      mergedParams: {},
    };
  },

  created() {
    this.mergedParams = { ...this.params };
  },

  methods: {
    isSelected(pos) {
      return this.posSelected === pos.id;
    },
    onSelect(pos) {
      this.setPOS(pos).then(() => {
        this.mergedParams = {
          ...this.mergedParams,
          pos_list: pos.id,
        };
        this.posSelected = pos.id;
      });
    },
    setPOS(pos) {
      return window.AngularEcommerce.ws.checkout.setPOS("current", {
        point_of_sale: pos.id,
      });
    },
  },
};
</script>